import React from 'react';
import './coreservices.css';

const ServiceCard = ({ service, onServiceClick, isMobile, index, isActive }) => {
  const handleCardClick = () => {
    onServiceClick(service.id);
  };

  const handleViewDetails = (e) => {
    e.stopPropagation();
    onServiceClick(service.id);
  };

  if (isMobile) {
    return (
      <div 
        className={`mobile-service-card ${isActive ? 'active' : ''}`}
        onClick={handleCardClick}
      >
        <img 
          src={service.image} 
          alt={service.title}
          className="service-image"
          onError={(e) => {
            e.target.src = "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80";
          }}
        />
        
        <div className="mobile-service-overlay">
          <div className="mobile-service-content">
            <h1 className="mobile-overlay-title">{service.title}</h1>
            <h2 className="mobile-overlay-description">{service.description}</h2>
            <button 
              className="mobile-view-details-btn"
              onClick={handleViewDetails}
            >
              View Details →
            </button>
          </div>
        </div>
        
        <div className="mobile-card-indicator">
          {index + 1}/{6}
        </div>
      </div>
    );
  }

  // Desktop version remains the same
  return (
    <div 
      className="service-card-wrapper"
      onClick={handleCardClick}
    >
      <div className="service-card-container">
        <div className="service-card">
          <img 
            src={service.image} 
            alt={service.title}
            className="service-image"
            onError={(e) => {
              e.target.src = "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80";
            }}
          />

          <div className="service-overlay">
            <div className="service-content1">
              <h1 className="overlay-title-text">{service.title}</h1>
              <h2 className="overlay-description">{service.description}</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="service-title-below">
        <h5 className="service-title-text">{service.title}</h5>
      </div>
    </div>
  );
};

export default ServiceCard;